import { Component, input, output } from '@angular/core';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';

import { Media } from '@eiq/files/models';

@Component({
  selector: 'empathy-welcome-page-view',
  templateUrl: 'welcome-page-view.component.html',
  styleUrls: ['./welcome-page-view.component.scss', './_welcome-page-view-theme.component.scss']
})
export class WelcomePageViewComponent {
  welcomeDetails = input<{ stimulus: Media[]; html: string; title: string; useTitleInd: boolean }>();

  start = output();

  faArrowRight = faArrowRight;
}
